import { useEffect, useState } from 'react';
import {
  transformPluginsApi,
  type TransformPluginRow,
} from '@/features/admin/transform-plugins/api/transform-plugins-client';

/**
 * Fetches the tenant's published transform plugins once on mount — the set
 * the transform-chain step picker merges into its family groups (F-043).
 * Drafts/archived plugins are never resolvable at export time, so the
 * picker only ever needs `published`.
 */
export function usePublishedTransformPlugins() {
  const [plugins, setPlugins] = useState<TransformPluginRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    transformPluginsApi
      .listPublished()
      .then((res) => {
        if (!cancelled) setPlugins(res.plugins);
      })
      .catch(() => {
        // Best-effort: the picker still functions with built-ins only if
        // the plugin fetch fails (e.g. permission denied on this tenant).
        if (!cancelled) setPlugins([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { plugins, loading };
}
